import React, { useState, useEffect } from 'react';
//import axios from 'axios';
import axiosIntance from '../../helper/axios'
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import './cscodes.css';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { baseUrl } from '../../config';
import { clickColor, inArray } from './../../library/util';
import Loader from "react-loader-spinner";
function Csscodes() {
  console.log('csscodes')
  const history = useHistory();
  const [selectedRow, setSelectedRow] = useState(null);
  const [loader, setLoader] = useState(false)
  checkUserTypeFn(history);
  const [selectedrowList, setSelectedRowList] = useState([]);


  const setRowBackground = (selectedRow) => {
    if (inArray(selectedRow.tableData.id, selectedrowList) == false) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }

  function checkUserTypeFn(history) {
    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const usertype = userdata.type;
    if (usertype != 'admin' && usertype != 'superadmin' && usertype != 'subadmin' && usertype != 'databasehelper' && usertype != 'owneradmin') {
      history.push('/');
    }

  }
  const handleSignOut = () => {
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null) {
    history.push('/');
  }
  const [cssCodesData, setcssCodesData] = useState([])

  const [message, setMessage] = useState('')
  const [successMsg, setSuccessMsg] = useState('')
  const data = [['attribute', 'attribute2'], ['value1', 'value2']];

  useEffect(() => {
    setLoader(true)
    axiosIntance.get(baseUrl + '/csscodes', {}).then(response => {

      console.log(response.data.result)
      console.log(response.data.result.length)
      if (response.data.result.length > 0) {
        console.log('data we have')
        setcssCodesData(response.data.result);
        console.log(response.data.result)


      }
      setLoader(false)
    }).catch(error => {
      setMessage('Something went wrong');
    });


    return () => {
      console.log('un subscribe')
    }



  }, [])

  const SubmitDelete = (e) => {

    confirmAlert({
      title: '',
      message: 'Are you sure want to delete All data',
      buttons: [
        {
          label: 'Yes',
          onClick: () =>
          axiosIntance.delete(baseUrl + '/csscodes', {}).then(response => {
              setSuccessMsg('Deleted!')
            }).catch(error => {
              setMessage('Something went wrong');
            })

        },
        {
          label: 'No',
          onClick: () => console.log('No')
        }
      ]
    });
  }
  return (
    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />


      <div className='delete-div'>
        {
          cssCodesData.length > 0 ? <button type="button" onClick={SubmitDelete} className="btn btn-primary">Delete All </button> : ''

        }

      </div>
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>


      <section id="content-wrapper">

        {loader &&
          <div className='loaderDiv'>
            <Loader
              type="Circles"
              color="#b4d6fa"
              height={100}
              width={100}
            />
          </div>
        }
        <MaterialTable

          onRowClick={((evt, selectedRow) =>
            setRowBackground(selectedRow)
          )}

          columns={[
            { title: "Code", field: "code" },
            { title: "Translation", field: "translation" },

          ]}
          data={
            cssCodesData
          }
          options={{
            maxBodyHeight: '500px',
            headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
            })
          }}
          title="CS Codes Data"

        />
      </section>
    </div>
  )
}

export default Csscodes
